import React from "react"
import {connect} from "react-redux"
import {TableFieldItemProps, TableObjData} from "../../util/interfaceData"
import TableFieldStyles from "./tableField.less"

export class TableField extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
    }

    render() {
        const tableField = this.props.table.map((item: TableObjData, index: number) => {
            return <TableItem data={item} key={index} />
        })
        return [tableField]
    }
}

const TableItem = (props: TableFieldItemProps) => {
    const tableCol = props.data.tableHead.map((item, index) => {
        return [
            <td className={TableFieldStyles.colTd} key={index}>
                {item}
            </td>,
        ]
    })
    const tableData =
        props.data.tableData &&
        props.data.tableData.data.map((item, index) => {
            const tableField = item.map((data, index) => {
                return (
                    <td className={TableFieldStyles.td} key={index}>
                        {data}
                    </td>
                )
            })
            return [
                <tr className={TableFieldStyles.colTr} key={index}>
                    <td className={TableFieldStyles.colTdNum}>{index + 1}</td>
                    {tableField}
                </tr>,
            ]
        })
    return (
        <div className={TableFieldStyles.tableBox}>
            <span>{props.data.tableData && props.data.tableData.tablename}</span>
            <table className={TableFieldStyles.fieldTable}>
                <tr className={TableFieldStyles.colTr}>
                    <td className={TableFieldStyles.colTd}>列号</td>
                    {tableCol}
                </tr>
                {tableData}
            </table>
        </div>
    )
}

const TableFieldItem = (props: TableFieldItemProps) => {
    const tableHead = props.data.tableHead.map((item: string, index: number) => {
        return (
            <div key={index} className={TableFieldStyles.colName}>
                <span>{item}</span>
            </div>
        )
    })
    const tableData =
        props.data.tableData &&
        Array.isArray(props.data.tableData.data) &&
        props.data.tableData.data.map((item: Array<string>, index: number) => {
            const inlineData =
                Array.isArray(item) &&
                item.map((inlineData: string, index: number) => {
                    return (
                        <div key={index} className={TableFieldStyles.colName}>
                            <span>{inlineData}</span>
                        </div>
                    )
                })
            return [
                <div key={index} className={TableFieldStyles.tableField}>
                    <div className={TableFieldStyles.colNum}>
                        <span>{index + 1}</span>
                    </div>
                    {inlineData}
                </div>,
                <br key={new Date().getTime()} />,
            ]
        })
    return (
        <div className={TableFieldStyles.tableFieldBox}>
            <div className={TableFieldStyles.tableName}>{props.data.tableData && props.data.tableData.tablename}</div>
            <div className={TableFieldStyles.tableFieldHead}>
                <div className={TableFieldStyles.colNum}>
                    <span>列号</span>
                </div>
                {tableHead}
            </div>
            <br />
            {tableData}
            <div className={TableFieldStyles.white} />
        </div>
    )
}

export default connect((state: any) => {
    return {
        table: state.table,
    }
})(TableField)
